import { BrowserRouter } from "react-router-dom"
import { Route, Routes } from "react-router-dom"

import Footer from "./components/Footer";
import Navigationbar from "./components/Navigationbar";
import Menubar from "./components/Menubar";

import Home from './routes/home/Home';
import Dienstleistungen from './routes/services/Dienstleistungen';
import Gemeinden from './routes/services/Gemeinden';
import Private from './routes/services/Private';
import Führungen from './routes/tour/Führungen';
import Gartentipps from './routes/tipps/Gartentipps';
import Events from './routes/events/Events';
import News from './routes/news/News';
import Downloads from './routes/downloads/Downloads';

import "./i18n";

import './App.css';

import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Avenir',
      'Roboto',
      'sans-serif'
    ].join(','),
  }
});

function App() {

  return (
    <ThemeProvider theme={theme}>
    <div className="App">
      <BrowserRouter>

      <Navigationbar />
      <Menubar />
      
        <Routes>
          <Route exact path="/" element={<Home />} />

          <Route exact path="/services" element={<Dienstleistungen />} />

          <Route exact path="/public" element={<Gemeinden />} />

          <Route exact path="/private" element={<Private />} />

          <Route exact path="/tours" element={<Führungen />} />

          <Route exact path="/gardentips" element={<Gartentipps />} />

          <Route exact path="/news" element={<News />} />

          <Route exact path="/events" element={<Events />} />

          <Route exact path="/downloads" element={<Downloads />} />
         
        </Routes>
        
      </BrowserRouter>
      
      <Footer />
    </div>
    </ThemeProvider>
  );
  
    
   

}

export default App;
